import { render, staticRenderFns } from "./OtherServicesList.vue?vue&type=template&id=63b1124e&"
import script from "./OtherServicesList.vue?vue&type=script&lang=ts&"
export * from "./OtherServicesList.vue?vue&type=script&lang=ts&"
import style0 from "./OtherServicesList.vue?vue&type=style&index=0&id=63b1124e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports